// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::-webkit-scrollbar {
    width: 10px;
}

::-webkit-scrollbar-thumb {
    background: rgba(128, 128, 128, 0.4);
    border-radius: 15px;
}

::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 15px;
}

:root {
    --app-bar-height: 2.5rem;
    --mirage-primary-hover: rgba(3, 87, 166, 0.8);
    --mirage-primary: #0357a6;
    --mirage-secondary-focus: rgba(3, 87, 166, 0.4);
    --mirage-small-hover: rgba(4, 86, 159, 0.8);
}
* {
    border: 0;
    box-sizing: border-box;
    list-style: none;
    margin: 0;
    outline: 0;
    padding: 0;
    text-decoration: none;
}

body {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
    height: 100%;
    overflow: auto;
}

code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

html {
    height: 100%;
    scroll-behavior: smooth;
}
#root {
    height: 100%;
}

.alignSelf-center {
    align-self: center;
}

.applicationHeaderContainer {
    background: white;
    position: sticky;
    top: calc(var(--app-bar-height));
    z-index: 1200;
}

.block--bottom {
    bottom: 0;
}

.block--left {
    left: 0;
}

.block--right {
    right: 0;
}

.block--top {
    top: 0;
}

.box--fullScreen {
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
}

.box--hidden {
    visibility: hidden;
}

.box--leftMargined {
    margin-left: 50px;
}

.box--overHeader {
    z-index: 1200;
}

.box--textAlignedCenter {
    text-align: center;
}

.box--verticalMargined {
    margin: 10px 0;
}

.box__buttonsContainer {
    display: flex;
    gap: 2rem;
    justify-content: center;
    padding: 1rem;
}

.buttons {
    display: flex;
    gap: 2rem;
    padding: 1rem;
}

.buttons--centered {
    justify-content: center;
}

.container {
    margin: 0 auto;
    padding: 1rem 0 1rem;
    position: relative;
    width: 90vw;
}
.display-none {
    display: none;
}

.EntityTable__cell--required.MuiDataGrid-cell--editing:not(:focus-within) {
    box-shadow: inset 0 0 0 1px #e74c3c !important;
}

.EntityTable_lookup_dialog {
    padding: 2rem;
    width: 80%;
}

.EntityTable_lookupDialog__title {
    display: flex;
    justify-content: space-between;
}

.flex-basis-0 {
    flex-basis: 0;
}

.flex-column {
    display: flex;
    flex-direction: column;
}

.flex-grow-1 {
    flex-grow: 1;
}

.headerContainer {
    padding: 1rem 0 1rem 2rem;
}

.map-control {
    position: absolute;
    z-index: 1000;
}

.margin-1rem {
    margin: 1rem;
}

.mirageRecordContainer {
    padding: 2rem;
}

.mirageRecordContainer__title {
    margin: 2rem 0;
    text-align: center;
}

.mr-1rem {
    margin-right: 1rem;
}

.MuiFormControl-root span {
    font-size: 0.8rem;
    line-height: 1rem;
}

.noscroll {
    overflow: hidden;
}

.padding-0 {
    padding: 0;
}

.recordTabContent {
    gap: 1rem;
}
.recordTabs {
    margin: 0 auto 1rem;
    width: 100%;
}

.tabBox {
    display: flex;
    flex-direction: column;
    margin: 1rem 0 0 4rem;
}

.tabBox__body {
    margin-bottom: 1rem;
    margin-top: 1rem;
    width: calc(100% - 4rem);
}

.tabBox__body--noMarginTop {
    margin-top: 0;
}
.tabBox__header {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.tabBox__searchInput {
    width: 100%;
}

.tabBox__tabsContainer .MuiTabs-flexContainer {
    justify-content: start;
}

.tabBox__title {
    display: flex;
    flex-direction: column;
}
.tabBox__title--primary {
}

.tabBox__title--secondary {
    opacity: 0.6;
}
.tabsContainer {
    display: flex;
    padding: 1rem 0rem 1rem 2rem;
}
.viewRecord {
    padding-top: 0.5rem;
}
.viewRecord__documentsContainer {
    padding-top: 2rem;
}
.viewRecord__sectionsContainer {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 0.5rem;
}
.width-50 {
    width: 50%;
}
.width-fit-content {
    width: fit-content;
}
.text-twoLinesEllipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    @supports (-webkit-line-clamp: 2) {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: initial;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
}
`, "",{"version":3,"sources":["webpack://./../index.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,6CAA6C;IAC7C,yBAAyB;IACzB,+CAA+C;IAC/C,2CAA2C;AAC/C;AACA;IACI,SAAS;IACT,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,mCAAmC;IACnC,8JAA8J;IAC9J,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,+EAA+E;AACnF;;AAEA;IACI,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,SAAS;IACT,OAAO;IACP,eAAe;IACf,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,aAAa;AACjB;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;AACb;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;AACA;;AAEA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,4BAA4B;AAChC;AACA;IACI,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;;IAEhB;QACI,gBAAgB;QAChB,uBAAuB;QACvB,oBAAoB;QACpB,oBAAoB;QACpB,qBAAqB;QACrB,4BAA4B;IAChC;AACJ","sourcesContent":["::-webkit-scrollbar {\n    width: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n    background: rgba(128, 128, 128, 0.4);\n    border-radius: 15px;\n}\n\n::-webkit-scrollbar-track {\n    background: transparent;\n    border-radius: 15px;\n}\n\n:root {\n    --app-bar-height: 2.5rem;\n    --mirage-primary-hover: rgba(3, 87, 166, 0.8);\n    --mirage-primary: #0357a6;\n    --mirage-secondary-focus: rgba(3, 87, 166, 0.4);\n    --mirage-small-hover: rgba(4, 86, 159, 0.8);\n}\n* {\n    border: 0;\n    box-sizing: border-box;\n    list-style: none;\n    margin: 0;\n    outline: 0;\n    padding: 0;\n    text-decoration: none;\n}\n\nbody {\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n    height: 100%;\n    overflow: auto;\n}\n\ncode {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\", monospace;\n}\n\nhtml {\n    height: 100%;\n    scroll-behavior: smooth;\n}\n#root {\n    height: 100%;\n}\n\n.alignSelf-center {\n    align-self: center;\n}\n\n.applicationHeaderContainer {\n    background: white;\n    position: sticky;\n    top: calc(var(--app-bar-height));\n    z-index: 1200;\n}\n\n.block--bottom {\n    bottom: 0;\n}\n\n.block--left {\n    left: 0;\n}\n\n.block--right {\n    right: 0;\n}\n\n.block--top {\n    top: 0;\n}\n\n.box--fullScreen {\n    bottom: 0;\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n}\n\n.box--hidden {\n    visibility: hidden;\n}\n\n.box--leftMargined {\n    margin-left: 50px;\n}\n\n.box--overHeader {\n    z-index: 1200;\n}\n\n.box--textAlignedCenter {\n    text-align: center;\n}\n\n.box--verticalMargined {\n    margin: 10px 0;\n}\n\n.box__buttonsContainer {\n    display: flex;\n    gap: 2rem;\n    justify-content: center;\n    padding: 1rem;\n}\n\n.buttons {\n    display: flex;\n    gap: 2rem;\n    padding: 1rem;\n}\n\n.buttons--centered {\n    justify-content: center;\n}\n\n.container {\n    margin: 0 auto;\n    padding: 1rem 0 1rem;\n    position: relative;\n    width: 90vw;\n}\n.display-none {\n    display: none;\n}\n\n.EntityTable__cell--required.MuiDataGrid-cell--editing:not(:focus-within) {\n    box-shadow: inset 0 0 0 1px #e74c3c !important;\n}\n\n.EntityTable_lookup_dialog {\n    padding: 2rem;\n    width: 80%;\n}\n\n.EntityTable_lookupDialog__title {\n    display: flex;\n    justify-content: space-between;\n}\n\n.flex-basis-0 {\n    flex-basis: 0;\n}\n\n.flex-column {\n    display: flex;\n    flex-direction: column;\n}\n\n.flex-grow-1 {\n    flex-grow: 1;\n}\n\n.headerContainer {\n    padding: 1rem 0 1rem 2rem;\n}\n\n.map-control {\n    position: absolute;\n    z-index: 1000;\n}\n\n.margin-1rem {\n    margin: 1rem;\n}\n\n.mirageRecordContainer {\n    padding: 2rem;\n}\n\n.mirageRecordContainer__title {\n    margin: 2rem 0;\n    text-align: center;\n}\n\n.mr-1rem {\n    margin-right: 1rem;\n}\n\n.MuiFormControl-root span {\n    font-size: 0.8rem;\n    line-height: 1rem;\n}\n\n.noscroll {\n    overflow: hidden;\n}\n\n.padding-0 {\n    padding: 0;\n}\n\n.recordTabContent {\n    gap: 1rem;\n}\n.recordTabs {\n    margin: 0 auto 1rem;\n    width: 100%;\n}\n\n.tabBox {\n    display: flex;\n    flex-direction: column;\n    margin: 1rem 0 0 4rem;\n}\n\n.tabBox__body {\n    margin-bottom: 1rem;\n    margin-top: 1rem;\n    width: calc(100% - 4rem);\n}\n\n.tabBox__body--noMarginTop {\n    margin-top: 0;\n}\n.tabBox__header {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.tabBox__searchInput {\n    width: 100%;\n}\n\n.tabBox__tabsContainer .MuiTabs-flexContainer {\n    justify-content: start;\n}\n\n.tabBox__title {\n    display: flex;\n    flex-direction: column;\n}\n.tabBox__title--primary {\n}\n\n.tabBox__title--secondary {\n    opacity: 0.6;\n}\n.tabsContainer {\n    display: flex;\n    padding: 1rem 0rem 1rem 2rem;\n}\n.viewRecord {\n    padding-top: 0.5rem;\n}\n.viewRecord__documentsContainer {\n    padding-top: 2rem;\n}\n.viewRecord__sectionsContainer {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin-top: 0.5rem;\n}\n.width-50 {\n    width: 50%;\n}\n.width-fit-content {\n    width: fit-content;\n}\n.text-twoLinesEllipsis {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n\n    @supports (-webkit-line-clamp: 2) {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: initial;\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
